/**
 * theme.js - Central location for theme-related constants and utilities
 * This file contains colors, styling functions, and other theme-related
 * constants used throughout the application.
 */

// Party colors used for styling party-related components
export const PARTY_COLORS = {
  'ALP': '#E53935', // Labor - red
  'LIB': '#0D47A1', // Liberal - blue
  'GRN': '#43A047', // Greens - green
  'NAT': '#33691E', // Nationals - dark green
  'PHON': '#FF6F00', // One Nation - orange
  'UAP': '#FFD600', // United Australia - yellow
  'CA': '#6A1B9A', // Centre Alliance - purple
  'KAP': '#BF360C', // Katter's Australian Party - dark orange
  'IND': '#607D8B'  // Independent - grey/blue
};

// Party background colors (lighter versions)
export const PARTY_BG_COLORS = {
  'ALP': '#ffebee',
  'LIB': '#e3f2fd',
  'GRN': '#e8f5e9',
  'NAT': '#f1f8e9',
  'IND': '#eceff1'
};

// Party border colors
export const PARTY_BORDER_COLORS = {
  'ALP': '#ffcdd2',
  'LIB': '#bbdefb',
  'GRN': '#c8e6c9',
  'NAT': '#dcedc8',
  'IND': '#cfd8dc'
};

// Party text colors for headings
export const PARTY_HEADING_COLORS = {
  'ALP': '#c62828',
  'LIB': '#1565c0',
  'GRN': '#388e3c',
  'NAT': '#558b2f',
  'IND': '#455a64'
};

// Party text colors for body text
export const PARTY_TEXT_COLORS = {
  'ALP': '#d32f2f',
  'LIB': '#1976d2',
  'GRN': '#388e3c',
  'NAT': '#558b2f',
  'IND': '#546e7a'
};

// Chart colors
export const CHART_COLORS = [
  'rgba(54, 162, 235, 0.8)',  // blue
  'rgba(255, 99, 132, 0.8)',  // pink
  'rgba(255, 206, 86, 0.8)',  // yellow
  'rgba(75, 192, 192, 0.8)',  // teal
  'rgba(153, 102, 255, 0.8)', // purple
  'rgba(255, 159, 64, 0.8)'   // orange
];

// Chart text colors
export const CHART_TEXT_COLOR = '#374151';
export const CHART_AXIS_COLOR = '#4b5563';
export const CHART_GRID_COLOR = 'rgba(156, 163, 175, 0.15)';

// Seat margin classifications
export const getSeatMarginClassification = (margin) => {
  if (margin < 3) return 'Highly marginal seat';
  if (margin < 6) return 'Marginal seat';
  if (margin < 10) return 'Fairly safe seat';
  return 'Very safe seat';
};

// Population density classifications
export const getPopulationDensityClassification = (density) => {
  if (density > 1000) return 'High density urban area';
  if (density > 100) return 'Medium density suburban area';
  return 'Low density rural area';
};

// Voter engagement classifications
export const getVoterEngagementClassification = (percentage) => {
  if (percentage > 0.8) return 'Very high voter engagement';
  if (percentage > 0.7) return 'Average voter engagement';
  return 'Below average voter engagement';
};

// Function to get party color or default
export const getPartyColor = (party) => {
  return PARTY_COLORS[party] || PARTY_COLORS.IND;
};

// Currency formatter function
export const formatCurrency = (value) => {
  if (value === undefined || value === null) return 'N/A';
  
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
};

// Number formatter with commas
export const formatNumber = (value) => {
  if (value === undefined || value === null) return 'N/A';
  return value.toLocaleString();
}; 